import { query } from "@core/helpers/graphql";
import { GET_POPUPS_BY_KEYS } from "./_queries";

export const get_popups_by_keys_query = async (variables, options = {}) => {
    const { gql, popup_mockup } = options
    const result = await query(gql || GET_POPUPS_BY_KEYS({ popup_mockup }), variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
}
